const productConstants = {
    carId: 'd04876209b6a4087ae5b', //车险
    ygcxCardId:'0DBA04EAC3AE73681ED00DCFBDD85401', //阳光车险
    accountRiskId: '285bf02942434fccb4cd', //账户安全险
    healthId: 'b2637079b7744118b93f', //健康险
    gasId: 'f379499c7e6a4b029bd3', // 燃气
    pipelineId: 'adbfa4492ee641a4b41a', // 管道
    voltageId: 'c333d64b7a034edeae87', //电压
    womenId: 'AF735B7176AA262C63E6514C89058B8E',
    womenH5AppId:'559873267260CB044DE5563C936BD5E8',
    hkToulianId: '884132AB90B8BE2FC42A5FADCCAB696B',
    dhToulianId: '925D90242A8403E55F024C4CD539D0EC', //美利保-港股T+1
    giveZaId: 'BE615BC0F71742CEF7A546B7A5209702',
    zaEnjoyLifeId: 'FC20CF16F3771B8ADC870CF4BB98FAC0', //众安尊享一生id
    healthELifeId: 'DE72670708D28E3166218D001D8A104A',
    appLocalUrl: 'https://m-app.gomelife.com', //app线上
    platformType: '1',
    //carUrl: 'http://220.171.28.152:9080/wap/portal.do?url=Y0PkhmkFgFE6PKxd/EzxgA==', //车险测试
    carUrl: 'https://e.cic.cn/wap/portal.do?url=yu2hnObbpzbbFA9f--VvRg==', //车险线上
    costlyUrl:'https://waptest.huaguilife.cn/hgcms/dock/dock_product!redirectProductUrl.action?DockOperator=guom&DockProduct=056601020&AgentCode=',//华贵重疾
    tlCategoryName: '投连险',
    ZAcarId: '2E948A6F10C9A8690B4DF140515797DE', //众安车险产品码
    CAcarId: 'CE77A1352A5166D3078B0BC8BC39990B',
    bhfxId: '3A6C29A0F9908CAABFBB729034888F6F',
    bhflyxId: 'AE3042B1E11389267DD3A3057A01D5A0',
    channelId: '149422702087422192',
    channelIdGuanWang: '115858317832623835',
    //三款中华非车险
    seriousInjuryId: '71A06700C9EF99E4799C9FFBE9D4EAAC',
    driveCarId: 'A8C5048AE249D06E418B3B247E14AA7B',
    rideCarId: '362983938E6D55C5FED52447B4E04735',
    studentSafeId: 'F6730F035E0F9E1882886ECAADB05CCC',

    activityId: '145390035611851716',
    activityBrokenScreenId: 'A4684C30F51D5B32027EBC0E1038BDA5',
    activityOfflineBrokenScreenId:'C031D877817AA6DEDA6394EBC6A4758E',
    preventionId: '61D9D2BF120CB49269A3B1F88BC7225D', //防癌险
    buyPreventionId: '84A9C2CCB0F09B2D9424FE30A951EF22',//购买版防癌险

    followCarId: '21A557755289A7D94E30F184FD58473C', //随车行李险costlyDiseasesId
    penatesId: 'B1CFFA8BB0DB2C55A919F52E0DF6B2BE',
    accountRiskTwoId: 'E89396957D957F30048853D5AF0F46DC',//新的账户安全保
    voerseasMedicalId:'FE2FD110F858B88E45C69BFFD40BAE91', // 海外医疗
    millionsMedicalId: '243C912E70CC963532A0C5744A76474E',//国美安康保
    educationMoney: 'C85C71D05B86C1DB7182190FBBC300DF',//国美宝贝未来年金
    steadysurplusId:'0596974D9E9ABDFF429CAB02AD78CA06',// 美富保-稳盈年金
    externalWelfareId: '509B500F4E0E230DFE6BF9FA599CC7F1',//国美金控内部福利产品
    internalWelfareId: '1643AFABA03CCE30B4CD85DBAE9056E8',//银盈通补充医疗
    groupInsuranceId: '3C4EB25A903AD8A3AD89EEC25078ABDD', //国美员工福利计划
    medicalInsurance:'7BC7F105BDDE3333EF5F3E165B6BA4AB',////2019金控补充医疗

    zhonganyiliaoInsuranceId: 'B5FB8EDE8106B76D78B1AA8D9916983C', //众安补充医疗险
    leukaemiaBabyId: '1971E9F8296C8B2C3A1411A2DFDCBF6F', //信美宝贝(白血病)
    costlyDiseasesId:'ACF5CBA5C6B55A4A79ED435F640E5E6B',//华贵人寿重疾险
    strichenDiseasesId:'690BE6FB171983E737901016F5D69BBA', //美泰保
    mommyBabyId:'5747F5BE2AEE012CA68E318A88591509', //妈咪宝贝
    insureTKId:'C219682FFEC18D55324B8B5972911432', //泰康在线产品产品

    epidemicListId : '243215339D1AA6EE58B24B58AC9552E7', //国美员工关爱计划（抗击疫情）
    healthOnlineTkId : '39E8277B594AFCE508BC1B5294337499', //泰康在线健康有约产品
    kostaId:'F3D24A19D77A09D49A302588C8ECFDC5', //众惠三高百万医疗产品
    beRelievedAX : '4261B3EC4338CC6BCC61BD798156537C', // 安心1号百万医疗产品
    medicalPingAnId : '30CF7B51FB351D5606D4F9C1A0F2B37A',// E生平安·医疗险
    productYccxId : 'E7CFFDDCA645607013FED129DA3AF1E8', //永诚财险  室内装修意外伤害财险
    productPuhuiId : '131842E36702E06644E19AFE00645E14',
    //新添加保险:长乐泰
    cltToulianId:'4A693F2288F118FCB9386A3A9A3C18BA',
    //新添加保险:鑫溢保
    xybToulianId:'56D42D7A607F3D418E8047D8256FDF35',

    //阳光赠险美途保
    giveYg:'229D9DA9E0899BCCD2C299E675B5AC88',
    //阳光赠险美健保（重疾）
    giveZj:'E4FC2DC7D78D1B3511CD3DC277D7AB59',
    //新添加保险：中国人寿京康源
    jkyDiseasesId:'8E97219D733B3A85C3F263C20813636B',
};

if(process.env.NODE_ENV == 'development') { // 测试环境
    productConstants.healthVerify = 'http://test-mobile.health.pingan.com/ehis-hm/aitest/outindex.do';
}else { // 线上环境
    productConstants.healthVerify = 'https://mobile.health.pingan.com/ehis-hm/aitest/outindex.do';
}

export　{
    productConstants
};

export const golbalConstants = {
    sourceTerminal: 1,
    agentSourceTerminal: 5,
    sellChannel:'115858317832623835'
};


/* app环境  全局配置 */
export const golbalConstantsAPP = {
    sourceTerminal: 2,
    sellChannel:'115858317832623839',
    agentCompanyCode: 'gome_app'
};



// WEBPACK FOOTER //
// ./src/constants/constants.js